export const COURSE_PAUSE_REQUEST_COURSE_TYPE_OPTIONS = [
  { label: 'Academy', value: 'academy' },
  { label: 'Data Science', value: 'data_science' },
  { label: 'DevOps', value: 'devops' },
  { label: 'AI ML', value: 'ai_ml' },
];
